import React from 'react'

const SkillCard = ({
    logo,
    title,
    count
}) => {
    return <div className='px-3 md:w-56 w-full mx:auto bg-light text-dark rounded-lg border shadow-md'>
        <div className='h-32 flex items-center p-5'>
            <img width="100" className="rounded-t-lg mx-auto m-5" src={logo} alt="" />
        </div>
        <div className="p-5">
            <a href="#">
                <h5 className="mb-2 text-2xl font-bold tracking-tight ">{title}</h5>
            </a>
            <p className="mb-3 font-normal"><span className='font-bold text-danger'>  {count} years </span> experience</p>
            {/* <span class="inline-flex bg-danger items-center py-2 px-3 text-sm font-medium text-center text-light  rounded-lg  focus:ring-4 focus:outline-none">
                Favorite
            </span> */}
        </div>
    </div>
}

export default SkillCard